import styled from '@emotion/styled'

import {cssTheme} from '@vio/atlas/themes'
import {linariaMq} from '@vio/atlas/utils/breakpoints'

export const SecondaryOfferListWrapper = styled.ul<{
  isLoading?: boolean
}>`
  padding: 0;
  margin: 0;
  width: 100%;
  &.--horizontal {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    padding: ${({isLoading}) =>
        isLoading ? cssTheme.layout.spacing.s500 : cssTheme.layout.spacing.s200}
      ${cssTheme.layout.spacing.s200} 0;
    margin: 0;
    width: 100%;
    gap: ${({isLoading}) => (isLoading ? cssTheme.layout.spacing.s600 : 0)};
  }
`

export const SecondaryOfferListItem = styled.li`
  padding: 0;
  margin: 0;
  list-style: none;
  cursor: pointer;
  transition: background-color 0.1s;
  flex: 1;
  &.--horizontal {
    &.--is-split-booking-loading {
      padding: ${cssTheme.layout.spacing.s300} ${cssTheme.layout.spacing.s400} !important;
    }
    &:hover {
      background-color: ${cssTheme.colors.background.interactive.tertiaryHover};
      border-radius: ${cssTheme.layout.radius.md};
    }
  }
  ${linariaMq.desktopXs} {
    &.--vertical-inline {
      margin: 0 ${cssTheme.layout.spacing.s400};
      padding: 0 ${cssTheme.layout.spacing.s200};
      &:hover {
        background-color: ${cssTheme.colors.background.interactive
          .tertiaryHover};
        border-radius: ${cssTheme.layout.radius.md};
      }
    }
    &:hover {
      background-color: ${cssTheme.colors.background.interactive.tertiaryHover};
    }
  }
`
